import GraphicOptionGroup from '../GraphicOptionGroup';
import React from 'react';

const ParentOptionGroup = (props) => {
  return <GraphicOptionGroup {...props} />;
};

export default ParentOptionGroup;
